import { AxiosError } from "axios";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import {
  ICompanyAddDepositAccountsRequestBody,
  ICompanyAddDepositAccountsResponseBody,
} from "./companyAddDepositAccounts.jsonschema";

export const companyAddDepositAccounts =
  (axios: IAxiosInstance) =>
  async (body: ICompanyAddDepositAccountsRequestBody) => {
    try {
      const response =
        await axios.noRetry.post<ICompanyAddDepositAccountsResponseBody>(
          `/api/company/add-deposit-accounts`,
          body
        );
      return response;
    } catch (e) {
      const errorMessage =
        (e as AxiosError)?.response?.data ??
        "Error adding deposit accounts to company";
      throw errorMessage;
    }
  };
